import e from "@dialpad/dialtone-tokens/layered/themes/tokens-buttercream-colors.css?inline";
//#region themes/buttercream.js
var t = {
	brand: {
		css: e,
		name: "buttercream"
	},
	material: { name: "sandstone" }
};
//#endregion
export { t as default };
